import { render, staticRenderFns } from "./Reclassification.vue?vue&type=template&id=7ccf5c36&scoped=true&"
import script from "./Reclassification.vue?vue&type=script&lang=js&"
export * from "./Reclassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccf5c36",
  null
  
)

export default component.exports